'use client'

import { placeholderImageUri } from '@/utilities/placeholder'
import Image from 'next/image'
import React, { useState } from 'react'
import { MediaProps } from '.'
import { cssVariables } from '@/cssVariables'
import { cn } from '@/utilities/ui'

export const ImageWithFallback: React.FC<NonNullable<MediaProps['options']>> = ({ useHoverImageOverlay, sizes: sizeFromProps, ...rest }) => {
    const [uri, setUri] = useState(rest.src || placeholderImageUri)

    // NOTE: this is used by the browser to determine which image to download at different screen sizes
    const sizes = sizeFromProps
        ? sizeFromProps
        : Object.entries(cssVariables.breakpoints)
              .map(([, value]) => `(max-width: ${value}px) ${value * 2}w`)
              .join(', ')

    return (
        <picture className='group relative'>
            <Image
                {...rest}
                className={cn('aspect-video', rest.className)}
                sizes={sizes}
                src={uri}
                alt={rest.alt || ''}
                placeholder='blur'
                blurDataURL={placeholderImageUri}
                onError={(_e) => {
                    setUri(placeholderImageUri)
                }}
            />
            {useHoverImageOverlay && <div className='absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-300' />}
        </picture>
    )
}
